/* FAQ subject tabs.

   The five FAQ sections render stacked; this shows one at a time and switches
   between them from the buttons under the headline. The buttons live inside
   the first section, so that one is never hidden outright — its heading and
   questions are toggled instead, leaving the nav in place. Without JS every
   section simply shows, which is still a usable page. */
(() => {
  const nav = document.querySelector('.fw-faq__nav');
  if (!nav) return;

  const links = [...nav.querySelectorAll('.fw-faq__nav-link')];
  const idFor = (link) => (link.getAttribute('href') || '').replace('#', '');
  const panels = links
    .map((link) => document.getElementById(idFor(link)))
    .filter(Boolean);
  if (panels.length < 2) return;

  const show = (id) => {
    panels.forEach((panel) => {
      const active = panel.id === id;
      if (panel.contains(nav)) {
        // Keep this section rendered so the buttons stay on screen.
        panel
          .querySelectorAll('.fw-faq__heading, .fw-faq__item')
          .forEach((el) => { el.hidden = !active; });
      } else {
        panel.hidden = !active;
      }
    });
    links.forEach((link) =>
      link.classList.toggle('fw-faq__nav-link--active', idFor(link) === id)
    );
  };

  links.forEach((link) =>
    link.addEventListener('click', (event) => {
      event.preventDefault();
      const id = idFor(link);
      show(id);
      // Keep the URL shareable without jumping the page.
      history.replaceState(null, '', `#${id}`);
    })
  );

  const fromHash = location.hash.replace('#', '');
  show(panels.some((p) => p.id === fromHash) ? fromHash : panels[0].id);
})();
